// extracted by mini-css-extract-plugin
export default {"hero":"Streaming_hero__5iC47","mainContent":"Streaming_mainContent__EtcPV"};